var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditSolids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.editSolids{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "editSolids",
    d: "M12.25,1h-8.5C2.23,1,1,2.24,1,3.75v8.5C1,13.77,2.23,15,3.75,15h8.51c1.52,0,2.75-1.23,2.75-2.75v-8.5 C15,2.24,13.77,1,12.25,1z M13.5,12.25c0,0.69-0.56,1.25-1.25,1.25h-8.5c-0.41,0-0.75-0.21-0.98-0.51L12.99,2.77 C13.29,3,13.5,3.34,13.5,3.75V12.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditSolids);
export default __webpack_public_path__ + "static/media/icon_edit-solids.99289a37f886d6bee6a2769b18eb36b5.svg";
export { ForwardRef as ReactComponent };